import { css } from 'styled-components/macro';
import theme from 'app/theme';

export const BreadcrumbItemStyle = css`
  color: #626262;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  text-decoration: underline;
`;

export const BreadcrumbActiveItemStyle = css`
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: ${theme.palette.text.primary};
  display: flex;
  align-items: center;
`;

export const BreadcrumbContainerStyle = css`
  display: flex;
  height: 32px;
  align-items: center;
`;

export const EditedIconStyle = {
  icon: css`
    width: 18px;
    height: 18px;
    color: #a1aebd;
  `,
  button: css`
    width: 25px;
    height: 25px;
    bottom: 2px;
    margin-left: 10px;
  `,
};

export const DialogStyle = {
  title: css`
    font-size: 24px;
    font-weight: 700;
    line-height: 29px;
    margin-top: 8px;
    margin-bottom: 8px;
  `,
  input: css`
    background: #ededf6;
    border-radius: 3px;
    padding: 10px;
    font-weight: normal;
    font-size: 14px;
  `,
  action: css`
    margin-right: 24px;
    margin-bottom: 16px;
    margin-top: 20px;
  `,
  button: css`
    border-radius: 26px;
    padding: 12px 24px;
    width: 110px;
    height: 32px;
    font-weight: 600;
    letter-spacing: 1px;
  `,
  buttonSave: css`
    background-color: rgba(46, 64, 99, 1);
    color: white;
    &:hover {
      color: rgba(46, 64, 99, 1);
    }
  `,
};
